import { render, staticRenderFns } from "./process-operate.vue?vue&type=template&id=00b01fda&scoped=true&"
import script from "./process-operate.vue?vue&type=script&lang=js&"
export * from "./process-operate.vue?vue&type=script&lang=js&"
import style0 from "./process-operate.vue?vue&type=style&index=0&id=00b01fda&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b01fda",
  null
  
)

export default component.exports